module.exports = __webpack_public_path__ + "img/coming-soon.f78cde09.svg";